module.exports = __webpack_public_path__ + "static/gradientTwo-7c54fd72e700b3fef94a4d5ffabed985.png";